import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
/** @type {string} */
import IcArrowDown from "../../assets/icons/ic-arrow-down.svg";
import IcStar from "../icons/IcStar";
import {observer} from "mobx-react";
/** @type {string} */
import IcFolder from "../../assets/icons/ic-EdFolder.svg";
import EntryItem from "./EntryItem";
import FolderAddView from "./FolderAddView";
import {useStore} from "../../app/store";
import {ChromePicker} from "react-color";
import axios from "axios";
import Input from "../common/Input";
import {toast} from "react-toastify";
import {folderFileNameNotAllow, getErrorText} from "../../app/util";

const EntryLoop = ({
                       entryType,
                       entry,
                       depth,
                       mutateFoldersAndBookmarks,
                       isActionModal,
                       modalDepth,
                       withIcon,
                       withFiles,
                       parentTabWrap,
                   }) => {
    const {folderStore, pageStore} = useStore();
    const entryWrap = () => {
        let entryId = entry.folder === undefined ? entry._id : entry.folder._id;
        if (folderStore.checkExist(entryType, entryId)) {
            if (entryType === 'PAGE' && !isActionModal) {
                pageStore.setPageIndex(1);
            }
            return true;
        }
        return false;
    }

    // 즐겨찾기 아이콘
    let [isBookmark, setIsBookmark] = useState(false);
    useEffect(() => {
        let entryId = entry.folder ? entry.folder._id : entry._id;
        let checkBookmark = folderStore.bookmarks[entryType].some((s) => s.folder?._id === entryId);
        setIsBookmark(checkBookmark)
    }, [entry])


    const [color, setColor] = useState('');
    const [viewColorPicker, setViewColorPicker] = useState(false);
    const pickerRef = useRef(null);
    const setTargetX = useRef(0);
    const setTargetY = useRef(0);
    const setColorChips = useRef(null);
    const setColorSaveData = useRef(null);
    const [contextMenuTargetX, setContextMenuTargetX] = useState(0);
    const [contextMenuTargetY, setContextMenuTargetY] = useState(0);
    const [contextOpen, setContextOpen] = useState(false);
    const contextRef = useRef(null);
    const [changeInputVal, setChangeInputVal] = useState("");
    useEffect(() => {
        const handler = async (event) => {
            try {
                if (contextRef.current && !contextRef.current.contains(event.target)) {
                    setContextOpen(false);
                }
                if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                    if (!!setColorSaveData.current) {
                        await axios.patch(`/explorer/change/color`, setColorSaveData.current);
                        setTargetX.current = 0;
                        setTargetY.current = 0;
                        setColor('');
                        setColorSaveData.current = null;
                    }
                    setViewColorPicker(false);
                }
            } catch (e) {
                console.log("err===>", e);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => {
            document.removeEventListener("mousedown", handler);
        }
    }, []);


    const handleChangeColor = color => {
        setColor(color.hex);
        setColorChips.current.style.backgroundColor = color.hex;
        setColorSaveData.current = {
            folderId: entry._id,
            color: color.hex,
        }
    };
    const colorChipChk = (e, item) => {
        setViewColorPicker(true);
        setColor(entry.color);
        setTargetX.current = e.clientX;
        setTargetY.current = e.clientY;
    }


    const changeItemNameFunc = async (e, item) => {
        if (e.nativeEvent.isComposing) return;
        if (folderFileNameNotAllow(changeInputVal)) {
            toast("사용 불가능한 문자가 포함 되어있습니다.");
            return;
        }
        if (changeInputVal !== '') {
            if (changeInputVal === item.name) {
                toast('현재와 동일한 이름 입니다.');
            } else {
                try {
                    if (entry.folder) {
                        await folderStore.bookMarkChangeName(entryType, item, changeInputVal);
                    } else {
                        await folderStore.changeName(entryType, item, changeInputVal);
                    }
                    await mutateFoldersAndBookmarks();
                    // folderStore.setCurrentAfterActionInModal(folderStore.editorBoardList.path, 0);
                    toast(`변경 완료되었습니다.`);
                } catch (e) {
                    if (e.code && e.code === "ALREADY_EXIST_FILE_NAME") {
                        toast(getErrorText(e.code));
                    }
                } finally {
                    folderStore.folderNameChange = false;
                }
            }
        } else {
            toast('이름을 입력해주세요.');
        }
    }

    return (
        <EntryContainer
            className={`${entry.name} entry-item-cont`}
            data-id={entry._id}
        >
            <NavContents
                className={
                    (!entry.folder && folderStore.getCurrent(entryType, modalDepth) && (entry.path === folderStore.getCurrent(entryType, modalDepth).path) ? "active " : "") +
                    // (isSelected ? "active " : "") +
                    (entry.depth === 1 ? "tab-first" : "" ||
                    entry.depth === 2 ? "tab-second" : "" ||
                    entry.depth === 3 ? "tab-third" : "" ||
                    entry.depth === 4 ? "tab-fourth" : "")
                }
                onContextMenu={(e) => {
                    e.preventDefault();
                    setContextMenuTargetX(e.clientX);
                    setContextMenuTargetY(e.clientY);
                    setContextOpen(true);
                }}
            >
                {
                    entry.color &&
                    <ColorChipArea
                        className={"color-pick-chip"}
                        ref={setColorChips}
                        color={entry.color}
                        onClick={(e) => {
                            colorChipChk(e, entry);
                        }}
                    ></ColorChipArea>
                }

                <div className={"entry-loop-content-wrap"}>
                    {!!entry.children && !!entry.files && (withFiles ? entry.children.length + entry.files.length > 0 : entry.children.length > 0) && (
                        <ItemPlusMinus onClick={() => {
                            folderStore.folderNameChange = false;
                            folderStore.openCloseFolder(entryType, entry, modalDepth);
                        }}>
                            <img
                                className={`folder-arrow-icon ${folderStore.getOpenFolders(entryType, modalDepth).includes(entry._id) ? "rotate" : ""}`}
                                src={IcArrowDown} alt="arrow icon"/>
                        </ItemPlusMinus>
                    )}
                    <div
                        className={"wrap"}

                        onClick={async (e) => {
                            folderStore.setAddFolder('TREE', false);
                            if (entryWrap()) {
                                try {
                                    if (!isActionModal) {
                                        folderStore.folderNameChange = false;
                                        pageStore.clearSearch();
                                        await folderStore.setCurrent(entryType, entry.folder ? entry.folder : entry);
                                        if (entry.folder && entry.folder.id === folderStore.getCurrent(entryType, modalDepth).id) {
                                            document.querySelectorAll('.entry-item-cont').forEach(element => {
                                                if (element.getAttribute('data-id') === folderStore.getCurrent(entryType, modalDepth)._id) {
                                                    if (parentTabWrap) parentTabWrap.scrollTo({
                                                        top: element.getBoundingClientRect()?.top - 120,
                                                        behavior: 'smooth'
                                                    });
                                                }
                                            });
                                        }
                                    } else {
                                        await folderStore.setCurrentFolderInModal(modalDepth, entryType, entry, withFiles);
                                    }
                                    if (entryType === 'PAGE') {
                                        pageStore.setBreadCrumb(entry, entryType);
                                        pageStore.clearSearch();
                                    }
                                } catch (e) {
                                    console.log("err ===>", e);
                                }
                            }
                        }}
                    >
                        {withIcon && <img src={IcFolder} alt={`폴더: ${entry.name}}`}/>}
                        <span>{entry.name}</span>
                    </div>
                </div>
                <div className={"star-icon"}
                     onClick={async () => {
                         try {
                             let item = entry.folder === undefined ? entry : entry.folder;
                             if (isBookmark) {
                                 await folderStore.bookmarkFolder(entryType, item._id);
                                 setIsBookmark((prev) => !prev);
                                 mutateFoldersAndBookmarks();
                             } else {
                                 folderStore.setAddBookmark(entryType, {id: item._id, name: item.name}, isActionModal);
                             }
                         } catch (e) {
                             console.log("err===>", e);
                         }

                     }}>
                    <IcStar isActive={isBookmark}/>
                </div>

                {
                    viewColorPicker &&
                    <ColorPickerWraper ref={pickerRef} className={"folder-color-picker"} top={setTargetY.current}
                                       left={setTargetX.current}>
                        <ChromePicker
                            color={color}
                            onChangeComplete={handleChangeColor}
                        />
                    </ColorPickerWraper>
                }
            </NavContents>
            {
                !isActionModal &&
                contextOpen &&
                <ContextMenu ref={contextRef} top={contextMenuTargetY} left={contextMenuTargetX}>
                    <div className={"list"} onClick={async () => {
                        await folderStore.setCurrent(entryType, entry, 'NAMING');
                        setChangeInputVal(entry.name);
                        setContextOpen(false);
                    }}>
                        이름바꾸기
                    </div>
                </ContextMenu>
            }
            {
                folderStore.folderNameChange &&
                folderStore.getCurrent(entryType, modalDepth) &&
                entry._id === folderStore.getCurrent(entryType, modalDepth)._id && /// 이건 현재 아이디랑 가져온 아이디랑 같음
                <Input
                    inputType={"text"}
                    id={"nameChangeInput"}
                    className={`input-name ${entryType === 'PAGE' ? 'page' : ''}`}
                    placeholder={"이름을 입력해주세요."}
                    autoFocus={true}
                    onChange={(e) => {
                        setChangeInputVal(e.target.value)
                    }}
                    onBlur={async (e) => {
                        folderStore.folderNameChange = false;
                    }}
                    onKeyDown={async (e) => {
                        if (e.key === "Enter") {
                            await changeItemNameFunc(e, entry);
                        } else if (e.key === "Escape") {
                            folderStore.folderNameChange = false;
                        }
                    }}
                    value={changeInputVal}
                />
            }
            {
                isActionModal ?
                    folderStore.getOpenFoldersInModal(modalDepth, entryType).includes(entry._id) &&
                    !!entry.children &&
                    entry.children.map((children, idx) => (
                        <EntryLoop
                            entryType={entryType}
                            entry={children}
                            depth={entry.depth}
                            id={entry._id}
                            key={idx}
                            // setBreadBookmark={setBreadBookmark}
                            mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                            isActionModal={isActionModal}
                            modalDepth={modalDepth}
                            withIcon={withIcon}
                            withFiles={withFiles}
                            onClick={() => {

                            }}
                        />
                    )) : folderStore.getOpenFolders(entryType).includes(entry._id) &&
                    !!entry.children &&
                    entry.children.map((children, idx) => (
                        <EntryLoop
                            entryType={entryType}
                            entry={children}
                            depth={entry.depth}
                            id={entry._id}
                            key={idx}
                            mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                            isActionModal={isActionModal}
                            modalDepth={modalDepth}
                            withIcon={withIcon}
                            withFiles={withFiles}
                            onClick={() => {

                            }}
                        />
                    ))
            }
            {
                folderStore.addFolder.TREE && entry.path && entry.path === folderStore.getCurrent(entryType).path &&
                <FolderAddView
                    entryType={entryType}
                    depth={entry.depth + 1}
                    modalDepth={modalDepth}
                    mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                />
            }
            {
                withFiles && !!entry.files && entry.files.length > 0 && folderStore.getOpenFolders(entryType).includes(entry._id) &&
                entry.files.map((file, idx) => (
                    <EntryItem id={file._id} path={file.parent} key={`entry-item-${idx}`} name={file.name} idx={idx}
                               board={file.board} type={file.type}
                               mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                               modalDepth={modalDepth}
                               depth={entry.depth}/>
                ))
            }
        </EntryContainer>
    );
};


export const ItemButton = styled.div`
    cursor: pointer;
    width: 100%;
    position: relative;
    background: #f8f7f3;
`;
export const ItemPlusMinus = styled.button`
`;

export const ColorChipArea = styled.div`
    width: 10px;
    height: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -16px;
    z-index: 99;
    cursor: pointer;
    background-color: ${(props) => props.color};
`;
export const ColorPickerWraper = styled.div`
    z-index: 100;
    position: fixed;
    top: ${(props) => props.top + "px"};
    left: ${(props) => props.left + "px"};
`;


export const EntryContainer = styled.div`
    position: relative;

    img {
        pointer-events: none;
        width: 16px;
    }

    .input-name {
        position: absolute;
        top: 0;
        left: 50%;
        width: calc(100% - 30px);
        transform: translateX(-50%);

        &.page {
            top: -1px;
        }

        input {
            height: 30px !important;
            font-size: 13px !important;
            font-style: normal;
            font-weight: 400;
        }
    }

    .tab-first + .input-name {
        top: 7px;

        &.page {
            top: 4px;
        }
    }

    .tab-second + .input-name {
        padding-left: 30px;
    }

    .tab-third + .input-name {
        padding-left: 46px;
    }

    .tab-fourth + .input-name {
        padding-left: 80px;
    }
`;

export const NavContents = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin: 8px 16px;
    cursor: pointer;


    .entry-loop-content-wrap {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: var(--Gray-1000_-262626, #262626);
        overflow: hidden;

        .wrap {
            width: 100%;
            display: flex;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            letter-spacing: -0.13px;
            min-width: 0;
            overflow: hidden;
            flex: 1;

            img {
                margin-right: 5px;
            }

            > span {
                width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }

        .folder-arrow-icon {
            &.rotate {
                transform: rotate(90deg);
            }
        }
    }


    &.tab-second {
        padding-left: 32px;
    }

    &.tab-third {
        padding-left: 48px;
    }

    &.tab-fourth {
        padding-left: 82px;
    }

    &.active {
        .wrap {
            color: var(--primary-500-c-86733, #c86733);
            font-weight: 500;
        }
    }

    & .icStar {
        margin-left: auto;
    }
`;
const ContextMenu = styled.div`
    position: fixed;
    top: ${(props) => props.top + "px"};
    left: ${(props) => props.left + "px"};
    border-radius: 4px;
    z-index: 999999;
    overflow: hidden;
    width: 104px;

    & .list {
        font-weight: 400;
        padding: 3px 12px;
        color: #fff;
        font-size: 12px;
        cursor: pointer;
        background-color: #262626;
        line-height: 1;

        &:hover {
            background-color: #313131;
        }
    }

    & .list:first-child {
        padding: 7px 12px 3px;
    }

    & .list:last-child {
        padding: 3px 12px 7px;
    }
`;
export default observer(EntryLoop);